import React, { JSX } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Table,
  TableHead
} from "@mui/material";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { BillingPackage } from "../../../interfaces/BillingPackages";
import { ITEM_TYPES } from "../../../helpers/billingPackages";

interface Props {
  formData: BillingPackage;
}

function AlreadyPaidItems({ formData }: Props): JSX.Element {
  return (
    <Box sx={{ px: 1 }}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="span">Past Paid Items</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer>
            <Table sx={{ minWidth: 650 }} size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Note</TableCell>
                  <TableCell>Teeth</TableCell>
                  <TableCell align="right">Price</TableCell>
                  <TableCell align="right">Paid Amt.</TableCell>
                  <TableCell>Dis. %</TableCell>
                  <TableCell>Dis. Amt</TableCell>
                  <TableCell>Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(formData?.document?.nonPackaged || [])
                  .concat(formData?.document?.packaged || [])
                  .concat(formData?.document?.[ITEM_TYPES.ADDITIONAL] || [])
                  ?.filter((item) => item.isPaid)
                  ?.map((item) => (
                    <TableRow
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      key={item.description}
                    >
                      <TableCell>{item.description}</TableCell>
                      <TableCell>{item.note}</TableCell>
                      <TableCell>{(item.teeth || []).join(", ")}</TableCell>
                      <TableCell align="right">{item.grossTotal}</TableCell>
                      <TableCell align="right">{item.paidAmount}</TableCell>
                      <TableCell>{item.discountPercent}</TableCell>
                      <TableCell align="right">{item.discountAmt}</TableCell>
                      <TableCell align="right">{item.netAmount}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default AlreadyPaidItems;
